// ExportMenu — popover with CSV / JSON / Excel options.

import { useState } from "react";
import { Icon } from "@/lib/icons";

export type ExportFormat = "csv" | "json" | "xlsx";

export interface ExportMenuProps {
  onExport: (format: ExportFormat) => void;
}

const FORMATS: Array<{ value: ExportFormat; label: string }> = [
  { value: "csv", label: "CSV" },
  { value: "json", label: "JSON" },
  { value: "xlsx", label: "Excel (.xlsx)" },
];

export function ExportMenu({ onExport }: ExportMenuProps) {
  const [open, setOpen] = useState(false);
  return (
    <div className="lex-popover-wrap">
      <button
        type="button"
        className="lex-toolbar-btn"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <Icon.Export size={14} aria-hidden="true" />
        <span>Export</span>
      </button>
      {open ? (
        <>
          <div className="lex-popover-scrim" onClick={() => setOpen(false)} aria-hidden="true" />
          <div className="lex-popover" role="menu">
            <div className="lex-popover__heading">Export</div>
            {FORMATS.map(f => (
              <button
                key={f.value}
                type="button"
                role="menuitem"
                className="lex-popover__row"
                onClick={() => { onExport(f.value); setOpen(false); }}
              >
                <span>{f.label}</span>
              </button>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}

export default ExportMenu;
